import cn from 'classnames'

interface ToggleProps {
    className?: string
    checked?: boolean
    setChecked?: (checked: boolean) => void
}

const Toggle: React.FC<ToggleProps> = ({ checked, setChecked, className }) => {
    const toggle = () => {
        setChecked?.(!checked)
    }

    return (
        <div
            className={cn(
                'flex h-4 w-8 cursor-pointer items-center rounded-full',
                checked ? 'bg-mach-primary' : 'bg-mach-gray',
                className
            )}
            onClick={toggle}
        >
            <div
                style={{
                    height: '14px',
                    width: '14px',
                    borderRadius: '9999px',
                    transform: checked ? 'translateX(16px) scale(1.1)' : 'translateX(2px)',
                    transition: 'transform 300ms ease-in-out',
                    background:
                        'linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), radial-gradient(97.22% 97.22% at 34.72% 0%, #EEEEEE 0%, #E7E7E7 100%)',
                    boxShadow:
                        'inset 0.19998px 0.19998px 0.39996px #FFFFFF, inset 0.0999901px -0.799921px 7.99921px rgba(0, 0, 0, 0.05)',
                }}
            />
        </div>
    )
}

export default Toggle
